const wrapper = require("./src/wrapElement");

export const wrapPageElement = wrapper.wrapPageElement;
